<template>
  <page-view title="待审核申请列表">
    <template slot="action">
    </template>
    <a-card class="mb-3">
      <a-form-model
          :model="queryParams"
          ref="queryForm"
          class="exi_form v2" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label="申请人">
          <a-input style="width: 600px" v-model="queryParams.applyForTitle" placeholder="请输入申请人"/>
        </a-form-model-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
        <a-form-model-item>
          <a-radio-group @change="onSearch" v-model="queryParams.auditState" button-style="solid">
            <a-radio-button :value="undefined">
              全部
            </a-radio-button>
            <a-radio-button v-for="item in AuditStateEnum.getList()" :value="item.val" :key="item.val">
              {{ item.text }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item>
          <a-radio-group @change="onSearch" v-model="queryParams.applyForType" button-style="solid">
            <a-radio-button :value="undefined">
              全部
            </a-radio-button>
            <a-radio-button v-for="item in ApplyForTypeEnum.getList()" :value="item.val" :key="item.val">
              {{ item.text }}
            </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          ref="table"
          :columns="ApplyForColumns"
          :data="loadData"
          :pagination="{ showTotal: (total) => `共 ${total} 条` }"
          :rowKey="record => record.id">
        <template v-slot:applyForType="text,record">
          <a-tag color="green">{{ ApplyForTypeEnum.getAuditObj(text).text }}申请</a-tag>
        </template>
        <template v-slot:auditState="text,record">
          <a-tag :color="AuditStateEnum.getValOrCol(text).color">{{ AuditStateEnum.getValOrCol(text).value }}</a-tag>
        </template>
        <template v-slot:operation="text,record">
          <a v-if="record.auditState && record.auditState !==AuditStateEnum.WAIT[0] " @click="onView(record)">查看</a>
          <div v-else>
            <a @click="onAudit(record)">审核</a>
            <span v-if="record.applyForType == ApplyForTypeEnum.APPLY_FOR_TYPE_ENTER[0]">
              <a-divider type="vertical" />
              <a-button type="primary" size="small" @click="onSubmitApplyFor(record)" :loading="submitApplyForLoading">同意入库</a-button>
            </span>
          </div>
        </template>
      </s-table>
    </a-card>
    <AuditExpertStorageApplyFor ref="invVisible" @submitSuccess="onSearch()"></AuditExpertStorageApplyFor>
    <AuditExpertOutApplyFor ref="outVisible" @submitSuccess="onSearch()"></AuditExpertOutApplyFor>
    <AuditExpertEditPurchaseApplyFor ref="itemVisible"  @submitSuccess="onSearch()"></AuditExpertEditPurchaseApplyFor>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import { QueryApplyForIndex,SubmitAuditApplyFor } from '@/epp/expertmain/pendingauditapplyfor/api/ApplyForApi'
import {
  ApplyForColumns,
  ApplyForTypeEnum,
  AuditStateEnum,
} from '@/epp/expertmain/pendingauditapplyfor/util/ApplyForUtil'
import AuditExpertStorageApplyFor from './AuditExpertStorageApplyFor.vue'
import AuditExpertOutApplyFor from './AuditExpertOutApplyFor.vue'
import AuditExpertEditPurchaseApplyFor from './AuditExpertEditPurchaseApplyFor.vue'

export default {
  name: 'PendingAuditApplyForIndex',
  computed: {},
  components: {
    PageView,
    STable,
    AuditExpertStorageApplyFor,
    AuditExpertOutApplyFor,
    AuditExpertEditPurchaseApplyFor
  },
  created () {
  },
  activated () {
    this.onSearch()
  },
  data () {
    return {
      ApplyForTypeEnum,
      AuditStateEnum,
      ApplyForColumns,
      queryParams: {
        applyForTitle: undefined,
        applyForType: undefined,
        auditState: AuditStateEnum.WAIT[0]
      },
      loadData: parameter => {
        return QueryApplyForIndex({
          ...this.queryParams,
          ...parameter
        }).then(res => {
          return res
        })
      },
      applyForOpen: {
        invVisible: false,
        outVisible: false,
        itemVisible: false
      },
      submitApplyForLoading:false,
    }
  },
  methods: {
    onSearch () {
      this.$refs.table.refresh()
    },
    onReset () {
      this.queryParams = {
        applyForTitle: undefined,
        applyForType: undefined,
        auditState: AuditStateEnum.WAIT[0]
      }
      this.$refs.table.refresh(true)
    },
    onView ({ id, applyForType, applyForId }) {
      const visible = ApplyForTypeEnum.getAuditObj(applyForType).visible
      if (!visible) {
        this.$message.error('申请类型有误')
        return
      }
      if(this.$refs[visible]){
        this.$refs[visible].initData(id,true)
      }else{
        this.$error({
          title: '正在开发中...'
        })
      }
    },
    onAudit ({ id, applyForType, applyForId }) {
      const visible = ApplyForTypeEnum.getAuditObj(applyForType).visible
      if (!visible) {
        this.$message.error('申请类型有误')
        return
      }
      if(this.$refs[visible]){
        this.$refs[visible].initData(id)
      }else{
        this.$error({
          title: '正在开发中...'
        })
      }
    },
    // 同意入库
    onSubmitApplyFor(record){
      const applyForType = record.applyForType
      const visible = ApplyForTypeEnum.getAuditObj(applyForType).visible
      if (!visible) {
        this.$message.error('申请类型有误')
        return
      }
      if(this.$refs[visible]){
        this.handleSubmitApplyFor(record)
      }else{
        this.$error({
          title: '正在开发中...'
        })
      }
    },
    // 确定同意入库
    async handleSubmitApplyFor (record) {
      this.submitApplyForLoading = true
      const postData = {...record}
      try{
        postData.auditState = AuditStateEnum.APPROVE[0]
        const res = await SubmitAuditApplyFor(postData)
        if (res.code == 200) {
          this.$message.success('处理成功')
          this.onSearch()
        }
        this.submitApplyForLoading = false
      }catch(e){
        this.submitApplyForLoading = false
      }
    },
  }
}
</script>

<style scoped>
</style>
